export const DASHBOARD_STATS="api/dashboard"
export const DASHBOARD_REPORTS="api/reports/dashboard-data"
export const DASHBOARD_CHATS="api/reports/last-chats-by-type"
